import { CertificationType } from "@/models/backend/CustomerModels";

export const getCertificationImageSrc = (cert:CertificationType) =>{
    switch (cert) {
        case CertificationType.ISO9001:
            return require('@/assets/images/Certifications/iso9001.png');

        case CertificationType.ISO14001:
            return require('@/assets/images/Certifications/iso14001.png');

        case CertificationType.ANREPA:
            return require('@/assets/images/Certifications/anrepa.png');

        case CertificationType.EPAL:
            return require('@/assets/images/Certifications/epal.png');

        case CertificationType.NIMA:
            return require('@/assets/images/Certifications/nima.png');
    }
}